import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { ArrowUpRight } from "@phosphor-icons/react";

const ProductsLanding = ({ data }) => {
  const [visibleSections, setVisibleSections] = useState(
    Array(data?.length).fill(false)
  );
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.index;
          setVisibleSections((prev) => {
            const updated = [...prev];
            updated[index] = entry.isIntersecting; // Set visibility based on intersection state
            return updated;
          });
        });
      },
      { threshold: 0.5, rootMargin: "0px 0px -20% 0px" } // rootMargin to adjust visibility trigger
    );

    sectionRefs.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionRefs.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  return data?.map(({ name, description, background, slug, logo }, index) => (
    <div
      className={`flex scroll-section  w-full relative text-font  transition-all duration-500 overflow-hidden`}
      key={index}
      data-index={index}
      ref={(el) => (sectionRefs.current[index] = el)}
    >
      <div
        style={{ backgroundImage: `url(${background})` }}
        className={`absolute top-1/2 -translate-y-1/2 w-full h-full background ${
          index % 2 === 0 ? "left-0" : "right-0"
        }`}
      >
        <div
          className={`absolute bg-black opacity-80  mix-blend-multiply w-full h-full  transition ease-in duration-1000  ${
            index % 2 === 0 ? "left-0" : "right-0 "
          } ${
            visibleSections[index]
              ? "translate-y-[-100%] opacity-0 "
              : "translate-y-[0%] opacity-100"
          } `}
        ></div>
      </div>
      <div
        className={`xl:w-[55%]  h-full relative   flex flex-col py-24 xl:py-0 justify-center   transition ease-in duration-700 ${
          index % 2 === 0 ? "ml-auto xl:pl-48 xl:px-0 px-4" : "px-4 xl:px-24"
        }  ${
          visibleSections[index] && index % 2 === 0
            ? "xl:opacity-100  xl:scale-[1] "
            : "xl:opacity-0  xl:scale-[0.6]"
        } ${
          visibleSections[index] && index % 2 !== 0
            ? "xl:opacity-100 xl:scale-[1] "
            : "xl:opacity-0  xl:scale-[0.6]"
        }`}
      >
        <div className=" w-max">
          <img className="w-[12rem]" src={logo} alt="" />
        </div>
        {/* <h3 className="bebas text-white text-5xl xxl:text-6xl">{name}</h3> */}
        <div
          className="text-white text-lg xl:w-[80%] mt-2 leading-[1.6]"
          dangerouslySetInnerHTML={{ __html: description }}
        />{" "}
        <Link
          to={`/products/${slug}`}
          state={{ isBrand: true }}
          className="text-white mt-10 uppercase font-bold text-lg block hover:underline flex items-center gap-x-1 justifty-center  w-max"
        >
          <ArrowUpRight size={28} />
          View Solutions
        </Link>
      </div>
    </div>
  ));
};

export default ProductsLanding;
